import React from "react";

const Footer = () => {
  return (
    <div>
      <div className="container-fluid footer">
          <div className="row">
          <div className="col text-center pt-3">
                <h5>Travel</h5>
            </div>
          </div>
        <div className="row text-center">
          <div className="col py-2 text-muted">
            <small>Copyright 2021 Travel - anik nath</small>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
